import(/* webpackMode: "eager" */ "/codebuild/output/src2207719562/src/DADB/src/app/forgot-password/page.tsx");
